import React, { useState, useEffect, useRef, createRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import "./ClientProfile.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Link, useNavigate } from "react-router-dom";
import { AES, enc } from "crypto-js";
import { useParams } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import LeftArrow from "../../../images/icons/blue-left-arrow.svg";
import RoundImage from "../../../images/icons/round-image.svg";
import SingleUser from "../../../images/icons/single-user-icon.svg";
import EyeIcon from "../../../images/icons/eye-icon.svg";
import CompanyUrl from "../../../images/icons/webpage.svg";
import EmailIcon from "../../../images/icons/email.svg";
import BottomArrow from "../../../images/icons/down-arrow.svg";
import LocationIcon from "../../../images/icons/location.svg";
import PostalIcon from "../../../images/icons/postal-code.svg";
import PassportIcon from "../../../images/icons/passport.svg";
import PaymentIcon from "../../../images/icons/payment.svg";
import PhoneIcon from "../../../images/icons/phone-icon.svg";
import CostIcon from "../../../images/icons/cost1.svg";
import CompanyIcon from "../../../images/icons/company-type.svg";
import WhiteTick from "../../../images/icons/tick-arrow.svg";
import profile_image from "../../../images/user/Default_pfp.png";
import PicEdit from "../../../images/icons/profile-pic-edit.svg";
import EyeCrossed from "../../../images/icons/eye-crossed.svg";
import PasswordLock from "../../../images/icons/pass_lock.svg";
import Delete from "../../../images/icons/delete.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import Currencies from "../../../constants/currenciesList";
import Countries from "../../../constants/countries";
import { setNotification } from "../../../features/notification/notificationSlice.js";
import { logout, reset } from "../../../features/auth/authSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import {
  useClientView,
  useDeleteClientDetails,
  usePosition,
  useUpdateClientDetails,
} from "../../TimeTracker/TimeTrackerClient/useClientDetails.jsx";

const ClientProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { encryptedId } = useParams();
  const decodedId = decodeURIComponent(encryptedId.replace(/%2F/g, "/"));
  const decryptedBytes = AES.decrypt(decodedId, "encryptionKey");
  const id = decryptedBytes.toString(enc.Utf8);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [image, setImage] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [removeProfileImage, setRemoveProfileImage] = useState(false);
  const [fileSelectIsLoading, setFileSelectIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientNameIsValid, setClientNameIsValid] = useState(false);
  const [legalEntityName, setLegalEntityName] = useState("");
  const [legalEntityNameIsValid, setLegalEntityNameIsValid] = useState(false);
  const [shortName, setShortName] = useState("");
  const [shortNameIsValid, setShortNameIsValid] = useState(false);
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [accManager, setAccManager] = useState("");
  const [accManagerDropdownOpen, setAccManagerDropdownOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [accManagerIsValid, setAccManagerIsValid] = useState(false);
  const [contactPoint, setContactPoint] = useState("");
  const [contactPointDropdownOpen, setContactPointDropdownOpen] =
    useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [contactPointSearchTerm, setContactPointSearchTerm] = useState('');
  const [contactPointIsValid, setContactPointIsValid] = useState(false);
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyWebsiteIsValid, setCompanyWebsiteIsValid] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [country, setCountry] = useState("");
  const [countryIsValid, setCountryIsValid] = useState(false);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [cityIsValid, setCityIsValid] = useState(false);
  const [address, setAddress] = useState("");
  const [addressIsValid, setAddressIsValid] = useState(false);
  const [pincode, setPincode] = useState("");
  const [pincodeIsValid, setPincodeIsValid] = useState(false);
  const [vatNumber, setVatNumber] = useState("");
  const [billingContactName, setBillingContactName] = useState("");
  const [vatPercentage, setVatPercentage] = useState(0);
  const [billingContactPosition, setBillingContactPosition] = useState("");
  const [billContPosIsValid, setBillContPosIsValid] = useState(false);
  const [preferredCurrency, setPreferredCurrency] = useState("");
  const [currencyIsValid, setCurrencyIsValid] = useState(false);
  const [billingContactEmail, setBillingContactEmail] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [signatoryUserName, setSignatoryUserName] = useState("");
  const [signatoryEmail, setSignatoryEmail] = useState("");
  const [signatoryUserPosition, setSignatoryUserPosition] = useState("");
  const [signUserPosIsValid, setSignUserPosIsValid] = useState(false);
  const [signatoryMobileNo, setSignatoryMobileNo] = useState("");
  const [pocUserName, setPocUserName] = useState("");
  const [pocEmail, setPocEmail] = useState("");
  const [pocUserPosition, setPocUserPosition] = useState("");
  const [pocUserPosIsValid, setPocUserPosIsValid] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [countrySearchTerm, setCountrySearchTerm] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [stateSearchTerm, setStateSearchTerm] = useState("");
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [updatedClientProfiles, setUpdatedClientProfiles] = useState([]);
  const [isCompanyInfoOpen, setCompanyInfoOpen] = useState(true);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [isAddressOpen, setAddressOpen] = useState(true);
  const [isBillingOpen, setBillingOpen] = useState(true);
  const passwordConfirmationRef = useRef(null);
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [isSignatoryOpen, setSignatoryOpen] = useState(true);
  const [isPointOfContactOpen, setPointOfContactOpen] = useState(true);
  const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false);
  const [signatoryPositionDropdownOpen, setSignatoryPositionDropdownOpen] =
    useState(false);
  const [positionContactDropdownOpen, setPositionContactDropdownOpen] =
    useState(false);
  const [currency, setCurrency] = useState("");
  const [currencySearchTerm, setCurrencySearchTerm] = useState("");
  const [currencyList, setCurrencyList] = useState([]);
  const currencyDropdownRef = useRef(null);
  const clientNameRef = useRef(null);
  const legalEntityNameRef = useRef(null);
  const shortNameRef = useRef(null);
  const compWebsiteRef = useRef(null);
  const cityRef = useRef(null);
  const addressRef = useRef(null);
  const pincodeRef = useRef(null);
  const countryRef = useRef(null);
  const billContPosRef = useRef(null);
  const currencyRef = useRef(null);
  const signUserPosRef = useRef(null);
  const pocUserPosRef = useRef(null);
  const accManagerRef = useRef(null);
  const accManagerSelectDropdownRef = useRef(null);
  const contactPointRef = useRef(null);
  const contactPointSelectDropdownRef = useRef(null);
  const signatoryPositionDropdownRef = useRef(null);
  const positionContactDropdownRef = useRef(null);
  const [passwordError, setPasswordError] = useState("");
  const countryDropdownRef = useRef(null);
  const stateDropdownRef = useRef(null);
  const cropperRef = createRef();
  const passwordRef = useRef(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const [isSecurityOpen, setIsSecurityOpen] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  const [paymentMethodDropdownOpen, setPaymentMethodDropdownOpen] =
    useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const paymentMethodDropdownRef = useRef(null);
  const fileInputRef = useRef(null);

  // ── HubSpot company mapping ──────────────────────────────────────────────
  const [hubspotConnected, setHubspotConnected] = useState(false);
  const [hubspotDealSyncEnabled, setHubspotDealSyncEnabled] = useState(false);
  const [hubspotMappedCompanyId, setHubspotMappedCompanyId] = useState(null);
  const [hubspotMappedCompanyName, setHubspotMappedCompanyName] = useState(null);
  const [hubspotMapModalOpen, setHubspotMapModalOpen] = useState(false);
  const [hubspotCompanySearch, setHubspotCompanySearch] = useState("");
  const [hubspotCompanyResults, setHubspotCompanyResults] = useState([]);
  const [hubspotCompanySearchLoading, setHubspotCompanySearchLoading] = useState(false);
  const [hubspotSelectedCompany, setHubspotSelectedCompany] = useState(null);
  const [hubspotMapSaving, setHubspotMapSaving] = useState(false);
  const [hubspotDetailsModalOpen, setHubspotDetailsModalOpen] = useState(false);
  const hubspotSearchTimerRef = useRef(null);
  const user = useSelector((state) => state.auth.user);
  const { appSettings } = useSelector((state) => state.appSettings);
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const {
    data: clientView = [],
    isLoading,
    refetch: refetchClientProfiles,
    isError: clientViewError,
  } = useClientView(id, token);
  const {
    data: position = [],
    isLoading: positionLoading,
    isError,
  } = usePosition(token);
  const deleteClientMutation = useDeleteClientDetails(token);

  useEffect(() => {
    if (!isLoading && clientView) {
      setClientName(clientView.client_name);
      if (clientView.legal_entity_name) {
        setLegalEntityName(clientView.legal_entity_name);
      } else {
        setLegalEntityName("");
      }

       if (clientView.short_name) {
        setShortName(clientView.short_name);
      } else {
        setShortName("");
      }

      setEmail(clientView.email);
      setMobileNo(clientView.mobile_no);
      if (clientView.acc_manager) {
        setAccManager(clientView.acc_manager._id);
      } else {
        setAccManager("");
      }
      setUserSearchTerm("");
      setAccManagerDropdownOpen(false);
      setAccManagerIsValid(false);
      if (clientView.contact_point) {
        setContactPoint(clientView.contact_point._id);
      } else {
        setContactPoint(null);
      }
      setContactPointDropdownOpen(false);
      setContactPointIsValid(false);
      setAddress(clientView.address);
      setCountry(clientView.country);
      setState(clientView.state);
      if (clientView.city) {
        setCity(clientView.city);
      } else {
        setCity("");
      }
      if (clientView.pincode) {
        setPincode(clientView.pincode);
      } else {
        setPincode("");
      }
      if (clientView.vat_number) {
        setVatNumber(clientView.vat_number);
      } else {
        setVatNumber("");
      }
      if (clientView.billing_contact_name) {
        setBillingContactName(clientView.billing_contact_name);
      } else {
        setBillingContactName("");
      }
      if (clientView.vat_percentage) {
        setVatPercentage(clientView.vat_percentage);
      } else {
        setVatPercentage(0);
      }
      if (clientView.billing_contact_position) {
        setBillingContactPosition(clientView.billing_contact_position);
      } else {
        setBillingContactPosition("");
      }
      if (clientView.preferred_currency) {
        setPreferredCurrency(clientView.preferred_currency);
      } else {
        setPreferredCurrency("");
      }
      if (clientView.billing_contact_email) {
        setBillingContactEmail(clientView.billing_contact_email);
      } else {
        setBillingContactEmail("");
      }
      if (clientView.payment_method) {
        setPaymentMethod(clientView.payment_method);
      } else {
        setPaymentMethod("");
      }
      if (clientView.company_website) {
        setCompanyWebsite(clientView.company_website);
      } else {
        setCompanyWebsite("");
      }
      if (clientView.signatory_user_name) {
        setSignatoryUserName(clientView.signatory_user_name);
      } else {
        setSignatoryUserName("");
      }
      if (clientView.signatory_email) {
        setSignatoryEmail(clientView.signatory_email);
      } else {
        setSignatoryEmail("");
      }
      if (clientView.signatory_user_position) {
        setSignatoryUserPosition(clientView.signatory_user_position);
      } else {
        setSignatoryUserPosition("");
      }
      if (clientView.signatory_mobile_no) {
        setSignatoryMobileNo(clientView.signatory_mobile_no);
      } else {
        setSignatoryMobileNo("");
      }
      if (clientView.poc_user_name) {
        setPocUserName(clientView.poc_user_name);
      } else {
        setPocUserName("");
      }
      if (clientView.poc_email) {
        setPocEmail(clientView.poc_email);
      } else {
        setPocEmail("");
      }
      if (clientView.poc_user_position) {
        setPocUserPosition(clientView.poc_user_position);
      } else {
        setPocUserPosition("");
      }
      // setCompanyLogoName(clientView.company_logo);
      setAdditionalInfo(clientView.additional_info);
    }
  }, [isLoading, clientView]);

  // Fetch HubSpot connection status
  useEffect(() => {
    if (!token) return;
    axios
      .get("/api/integrations/hubspot/config", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setHubspotConnected(!!res.data?.connected);
        setHubspotDealSyncEnabled(res.data?.sync_deal_enabled !== false);
      })
      .catch(() => { setHubspotConnected(false); setHubspotDealSyncEnabled(false); });
    return () => clearTimeout(hubspotSearchTimerRef.current);
  }, [token]);

  // Sync mapped company from clientView
  useEffect(() => {
    if (clientView && !isLoading) {
      setHubspotMappedCompanyId(clientView.hubspot_company_id || null);
      setHubspotMappedCompanyName(clientView.hubspot_company_name || null);
    }
  }, [clientView, isLoading]);

  // ── HubSpot mapping handlers ─────────────────────────────────────────────
  const openHubspotMapModal = () => {
    setHubspotCompanySearch("");
    setHubspotCompanyResults([]);
    setHubspotSelectedCompany(null);
    setHubspotMapModalOpen(true);
  };

  const closeHubspotMapModal = () => {
    setHubspotMapModalOpen(false);
    setHubspotCompanySearch("");
    setHubspotCompanyResults([]);
    setHubspotSelectedCompany(null);
  };

  const searchHubspotCompanies = useCallback(async (q) => {
    if (!token) return;
    try {
      setHubspotCompanySearchLoading(true);
      const res = await axios.get(
        `/api/integrations/hubspot/companies/search?q=${encodeURIComponent(q)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setHubspotCompanyResults(res.data?.companies || []);
    } catch (err) {
      toast.error("Failed to search HubSpot companies.", { position: "bottom-right", autoClose: 2000 });
    } finally {
      setHubspotCompanySearchLoading(false);
    }
  }, [token]);

  const handleHubspotCompanySearchChange = (e) => {
    const q = e.target.value;
    setHubspotCompanySearch(q);
    setHubspotSelectedCompany(null);
    clearTimeout(hubspotSearchTimerRef.current);
    hubspotSearchTimerRef.current = setTimeout(() => searchHubspotCompanies(q), 400);
  };

  const handleSaveHubspotMap = async () => {
    if (!hubspotSelectedCompany) return;
    try {
      setHubspotMapSaving(true);
      await axios.post(
        "/api/integrations/hubspot/client-map",
        {
          clientId: id,
          companyId: hubspotSelectedCompany.id,
          companyName: hubspotSelectedCompany.name,
          companyDomain: hubspotSelectedCompany.domain,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setHubspotMappedCompanyId(hubspotSelectedCompany.id);
      setHubspotMappedCompanyName(hubspotSelectedCompany.name);
      toast.success(`Client mapped to "${hubspotSelectedCompany.name}" in HubSpot.`, { position: "bottom-right", autoClose: 2000 });
      closeHubspotMapModal();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save mapping.", { position: "bottom-right", autoClose: 2000 });
    } finally {
      setHubspotMapSaving(false);
    }
  };

  const handleRemoveHubspotMap = async () => {
    try {
      await axios.delete(
        `/api/integrations/hubspot/client-map/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setHubspotMappedCompanyId(null);
      setHubspotMappedCompanyName(null);
      setHubspotDetailsModalOpen(false);
      toast.success("HubSpot mapping removed.", { position: "bottom-right", autoClose: 2000 });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to remove mapping.", { position: "bottom-right", autoClose: 2000 });
    }
  };

  const handleRemapClick = () => {
    setHubspotDetailsModalOpen(false);
    openHubspotMapModal();
  };

  const handleProfilePicChange = () => {
    setFileSelectIsLoading(true);
    fileInputRef.current.click();
  };
  const handleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleFileInputCancel = () => {
    // Handle the case where the file selection window is canceled
    setFileSelectIsLoading(false);
  };

  // Attach event listeners to the file input
  useEffect(() => {
    const inputElement = fileInputRef.current;

    const handleChange = () => {
      handleFileInputChange({ target: { files: inputElement.files } });
    };

    const handleCancel = () => {
      handleFileInputCancel();
    };

    inputElement.addEventListener("change", handleChange);
    inputElement.addEventListener("cancel", handleCancel);

    return () => {
      inputElement.removeEventListener("change", handleChange);
      inputElement.removeEventListener("cancel", handleCancel);
    };
  }, []);

  const handleFileInputChange = (event) => {
    setFileSelectIsLoading(false);
    const file = event.target.files[0];
    setCompanyLogo(event.target.files[0]);
    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setUploadedImageUrl(fileReader.result);
        // setModalIsOpen(true);
      };
      // if (removeProfileImage) {
      setRemoveProfileImage(false);
      setDropdownVisible(false);
      // }
      fileReader.readAsDataURL(file);
    }
  };

  const closeModal = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setFileSelectIsLoading(false);
    setModalIsOpen(false);
  };
  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };
  const handleConfirmDelete = async () => {
    try {
      setIsSubmitLoading(true);
      await deleteClientMutation.mutateAsync(id);
      toast.success("Client removed successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Client",
        `Client (${id}) deleted successfully`
      );
      // handleCloseModal();
      refetchClientProfiles();
      navigate("/client/overview");
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsSubmitLoading(false);
    }
    setIsDeleteModalOpen(false);
  };
  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };
  const handleCropClick = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      const croppedImage = cropperRef.current?.cropper
        .getCroppedCanvas()
        .toDataURL();
      setUploadedImageUrl(croppedImage);
      setCompanyLogo(croppedImage);
    }
    closeModal();
  };

  // Function to resize the image
  const resizeImage = async (base64Image, maxWidth) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = base64Image;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const aspectRatio = image.width / image.height;
        const newHeight = maxWidth / aspectRatio;

        canvas.width = maxWidth;
        canvas.height = newHeight;

        context.drawImage(image, 0, 0, maxWidth, newHeight);

        const resizedImage = canvas.toDataURL("image/jpeg"); // Change to 'image/png' if needed
        resolve(resizedImage);
      };
    });
  };

  const togglePaymentMethodDropdown = () => {
    setPaymentMethodDropdownOpen(!paymentMethodDropdownOpen);
  };
  const selectPaymentMethodOption = (selectedPaymentMethod) => {
    setPaymentMethod(selectedPaymentMethod);
    setPaymentMethodDropdownOpen(false);
  };

  const [billingContactDropdownOpen, setBillingContactDropdownOpen] =
    useState(false);
  const [selectedBillingContact, setSelectedBillingContact] = useState(null);
  const billingContactDropdownRef = useRef(null);
  const toggleBillingContactDropdown = () => {
    setBillingContactDropdownOpen(!billingContactDropdownOpen);
  };

  const selectBillingContactOption = (selectedBillingContact) => {
    setSelectedBillingContact(selectedBillingContact);
    setBillingContactDropdownOpen(false);
  };

  const [selectedPosition, setSelectedPosition] = useState(null);

  const toggleSignatoryPositionDropdown = () => {
    setSignatoryPositionDropdownOpen(!signatoryPositionDropdownOpen);
  };

  const selectPositionOption = (selectedPosition) => {
    setSignatoryUserPosition(selectedPosition);
    setSignatoryPositionDropdownOpen(false);
  };

  const togglePositionContactDropdown = () => {
    setPositionContactDropdownOpen(!positionContactDropdownOpen);
  };

  const selectPositionContactOption = (selectedPositionContact) => {
    setPocUserPosition(selectedPositionContact);
    setPositionContactDropdownOpen(false);
  };

  useEffect(() => {
    setCurrencyList(Currencies.sourceCurrencies[0].targetCurrencies);
    const sortedCountries = Countries.slice().sort((a, b) =>
      a.country.localeCompare(b.country)
    );
    setCountriesList(sortedCountries);
  }, []);

  const toggleCompanyInfoAccordion = () => {
    setCompanyInfoOpen(!isCompanyInfoOpen);
  };

  const toggleAddressAccordion = () => {
    setAddressOpen(!isAddressOpen);
  };

  const toggleBillingAccordion = () => {
    setBillingOpen(!isBillingOpen);
  };

  const toggleSignatoryAccordion = () => {
    setSignatoryOpen(!isSignatoryOpen);
  };

  const togglePointOfContactAccordion = () => {
    setPointOfContactOpen(!isPointOfContactOpen);
  };

  const handleCurrencySearchInputChange = (e) => {
    setCurrencySearchTerm(e.target.value);
  };

  const filteredCurrencies = currencyList.filter((currency) => {
    const currencyName =
      currency.currencyCode &&
      `${currency.currencyCode} (${currency.currencyName})`;
    return currencyName
      ?.toLowerCase()
      .includes(currencySearchTerm?.toLowerCase());
  });

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    setCountryDropdownOpen(false);
  };

  const handleCountrySearchInputChange = (e) => {
    setCountrySearchTerm(e.target.value);
  };

  const filteredCountries = countriesList.filter((country) => {
    return country.country
      ?.toLowerCase()
      .includes(countrySearchTerm?.toLowerCase());
  });

  const handleToggleCountryDropdown = () => {
    setCountrySearchTerm("");
    setCountryDropdownOpen(!countryDropdownOpen);
  };

  const countryData = countriesList.find((c) => c.country === country);
  const states = countryData?.states || [];

  const handleStateSearchInputChange = (e) => {
    setStateSearchTerm(e.target.value);
  };

  const selectedCountry = countriesList.find((c) => c.country === country);
  const filteredStates = selectedCountry?.states?.filter((stateObj) =>
    stateObj.state.toLowerCase().includes(stateSearchTerm.toLowerCase())
  );

  const toggleSecurityAccordion = () => {
    setIsSecurityOpen(!isSecurityOpen);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideCountryDropdown =
      countryDropdownRef.current &&
      countryDropdownRef.current.contains(event.target);
    const isClickInsideStateDropdown =
      stateDropdownRef.current &&
      stateDropdownRef.current.contains(event.target);
    const isClickInsideCurrencyDropdown =
      currencyDropdownRef.current &&
      currencyDropdownRef.current.contains(event.target);
    const isClickInsidePaymentMethodDropdown =
      paymentMethodDropdownRef.current &&
      paymentMethodDropdownRef.current.contains(event.target);
    const isClickInsideBillingContactDropdown =
      billingContactDropdownRef.current &&
      billingContactDropdownRef.current.contains(event.target);
    const isClickInsideSignatoryPositionDropdown =
      signatoryPositionDropdownRef.current &&
      signatoryPositionDropdownRef.current.contains(event.target);
    const isClickInsidePositionContactDropdown =
      positionContactDropdownRef.current &&
      positionContactDropdownRef.current.contains(event.target);

    if (!isClickInsideCountryDropdown) {
      setCountryDropdownOpen(false);
    }
    if (!isClickInsideStateDropdown) {
      setStateDropdownOpen(false);
    }
    if (!isClickInsideCurrencyDropdown) {
      setCurrencyDropdownOpen(false);
    }
    if (!isClickInsidePaymentMethodDropdown) {
      setPaymentMethodDropdownOpen(false);
    }
    if (!isClickInsideBillingContactDropdown) {
      setBillingContactDropdownOpen(false);
    }
    if (!isClickInsideSignatoryPositionDropdown) {
      setSignatoryPositionDropdownOpen(false);
    }
    if (!isClickInsidePositionContactDropdown) {
      setPositionContactDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDropdown);
    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  const StatusChangeActive = async (id) => {
    try {
      setIsSubmitLoading(true);
      await axios.get(`/api/client/status-change/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(
        `${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account has been deactivated successfully!`,
        {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      global.config.activityLog(
        window.location.href,
        "User",
        `${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account has been deactivated successfully!`
      );
      dispatch(setNotification(Date.now()));
      refetchClientProfiles();
    } catch (error) {
      console.log("Something went wrong while deactivating client: ", error);
      toast.error(
        `Something went wrong while deactivating ${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account`,
        {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      global.config.activityLog(
        window.location.href,
        "User",
        `Something went wrong while deactivating ${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account!`
      );
      global.config.slackMessage(error.toString());
      console.log(error);
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const StatusChangeInactive = async (id) => {
    try {
      setIsSubmitLoading(true);
      await axios.get(`/api/client/status-change/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(
        `${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account has been activated successfully!`,
        {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      dispatch(setNotification(Date.now()));
      global.config.activityLog(
        window.location.href,
        "User",
        `${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account has been activated successfully!`
      );
      refetchClientProfiles();
    } catch (error) {
      console.log("Something went wrong while activating user: ", error);
      toast.error("Something went wrong in changing user status!",
        {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "User",
        `Something went wrong while activating ${clientView && clientView.client_name
          ? clientView.client_name
          : clientView.legal_entity_name
        }'s account!`
      );
      console.log(error);
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setAccManagerIsValid(false);
    setContactPointIsValid(false);
    setIsValidUrl(false);
    setClientNameIsValid(false);
    setLegalEntityNameIsValid(false);
    setShortNameIsValid(false);
    setCompanyWebsiteIsValid(false);
    setCountryIsValid(false);
    setCityIsValid(false);
    setAddressIsValid(false);
    setPincodeIsValid(false);
    setCurrencyIsValid(false);
    const pattern = /^(ftp|http|https):\/\/[^ "]+$/;
    if (
      clientName === "" ||
      legalEntityName === "" ||
      shortName === "" ||
      companyWebsite === "" ||
      !country ||
      city === "" ||
      address === "" ||
      pincode === "" ||
      billingContactPosition === "" ||
      preferredCurrency === "" ||
      signatoryUserPosition === "" ||
      pocUserPosition === ""
    ) {
      if (clientName === "") {
        setClientNameIsValid(true);
        clientNameRef && clientNameRef.current.focus();
        return;
      } else if (legalEntityName === "") {
        setLegalEntityNameIsValid(true);
        legalEntityNameRef && legalEntityNameRef.current.focus();
        return;
      } else if (shortName === "") {
        setShortNameIsValid(true);
        shortNameRef && shortNameRef.current.focus();
        return;
      } else if (companyWebsite === "") {
        setCompanyWebsiteIsValid(true);
        compWebsiteRef && compWebsiteRef.current.focus();
        return;
      } else if (!country) {
        setCountryIsValid(true);
        countryRef && countryRef.current.focus();
        return;
      } else if (city === "") {
        setCityIsValid(true);
        cityRef && cityRef.current.focus();
        return;
      } else if (address === "") {
        setAddressIsValid(true);
        addressRef && addressRef.current.focus();
        return;
      } else if (pincode === "") {
        setPincodeIsValid(true);
        pincodeRef && pincodeRef.current.focus();
        return;
      } else if (billingContactPosition === "") {
        setBillContPosIsValid(true);
        billContPosRef && billContPosRef.current.focus();
        return;
      } else if (preferredCurrency === "") {
        setCurrencyIsValid(true);
        currencyRef && currencyRef.current.focus();
        return;
      } else if (signatoryUserPosition === "") {
        setSignUserPosIsValid(true);
        signUserPosRef && signUserPosRef.current.focus();
        return;
      } else if (pocUserPosition === "") {
        setPocUserPosIsValid(true);
        pocUserPosRef && pocUserPosRef.current.focus();
        return;
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (companyWebsite && !pattern.test(companyWebsite)) {
      toast.error("It's not a valid URL.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsValidUrl(true);
      compWebsiteRef && compWebsiteRef.current.focus();
      return;
    }

    if (clientView.preferred_currency !== preferredCurrency) {
      toast.warning("Currency update will effect all related areas.", {
        position: "bottom-right",
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    const requestData = {
      client_name: clientName,
      legal_entity_name: legalEntityName,
      short_name: shortName,
      mobile_no: mobileNo,
      address,
      country,
      state,
      // acc_manager: accManager,
      // contact_point: contactPoint,
      city,
      pincode,
      vat_number: vatNumber,
      billing_contact_name: billingContactName,
      vat_percentage: vatPercentage,
      billing_contact_position: billingContactPosition,
      preferred_currency: preferredCurrency,
      billing_contact_email: billingContactEmail,
      payment_method: paymentMethod,
      company_website: companyWebsite,
      signatory_user_name: signatoryUserName,
      signatory_email: signatoryEmail,
      signatory_user_position: signatoryUserPosition,
      signatory_mobile_no: signatoryMobileNo,
      poc_user_name: pocUserName,
      poc_email: pocEmail,
      poc_user_position: pocUserPosition,
      additional_info: additionalInfo,
      password
    };

    const formData = new FormData();
    formData.append("company_logo", companyLogo);
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }
    if (removeProfileImage) {
      formData.append("removeProfileImage", true); // Add removeProfileImage flag
    }
    try {
      setIsSubmitLoading(true);
      await axios.put(`/api/client-details/update/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Client updated successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // handleCloseModal();
      global.config.activityLog(
        window.location.href,
        "Client",
        `Client (${clientName}) updated successfully`
      );
      refetchClientProfiles();
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      if (error.response?.data?.message === "Client name or legal entity name already exists") {
        toast.error("Client name or legal entity name already exists. Please choose a different name.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
      toast.error("Something went wrong while updating the client", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
    }
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
      <div className="text-arrow-outer text-arrow-outer-delete">
        <div className="text-arrow-inner">
          <Link
            to={`/client/details/${encodeURIComponent(
              AES.encrypt(id, "encryptionKey").toString().replace(/\//g, "%2F")
            )}`}
          >
            <div className="text-arrow">
              <div className="left-arrow">
                <img src={LeftArrow} alt="left-arrow" />
              </div>
              <div className="top-text">Back to Overview</div>
            </div>
          </Link>
        </div>
        <div className="delete-cliet">
          <div className="invite-client-outer" style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
            {/* HubSpot mapping button */}
            {hubspotConnected && hubspotDealSyncEnabled && !isLoading && (
              hubspotMappedCompanyId ? (
                <button
                  type="button"
                  onClick={() => setHubspotDetailsModalOpen(true)}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "7px",
                    padding: "0 16px",
                    height: "44px",
                    borderRadius: "6px",
                    border: "1.5px solid #ff7a59",
                    background: "#fff5f2",
                    color: "#cc4400",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="8" r="7.5" stroke="#ff7a59" strokeWidth="1.2" />
                    <path d="M5 8.5l2 2 4-4" stroke="#ff7a59" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  HubSpot Mapped
                </button>
              ) : (
                <button
                  type="button"
                  onClick={openHubspotMapModal}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "7px",
                    padding: "0 16px",
                    height: "44px",
                    borderRadius: "6px",
                    border: "1.5px solid #e5e7eb",
                    background: "#ffffff",
                    color: "#374151",
                    fontSize: "13px",
                    fontWeight: 500,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="8" r="7.5" stroke="#9ca3af" strokeWidth="1.2" />
                    <path d="M8 5v6M5 8h6" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                  Map to HubSpot
                </button>
              )
            )}
            <button
              type="button"
              className="delete-client"
              onClick={handleDelete}
              disabled={isSubmitLoading}
            >
              <img src={Delete} alt="Delete" />{" "}
              {global.config.locate(
                appSettings && appSettings.language,
                "Delete"
              )}
            </button>
            <Modal
              className="delete-modal"
              isOpen={isDeleteModalOpen}
              onRequestClose={handleCancelDelete}
              contentLabel="Confirm Delete"
              style={{
                content: {
                  height: "41%",
                  width: "30%",
                  position: "fixed",
                  top: "36%",
                  left: "50%",
                  parent: document.querySelector(".admin-outer.time.tracker"),
                },
              }}
            >
              <div className="delete-modal-content">
                <h2>
                  {global.config.locate(
                    appSettings && appSettings.language,
                    "Confirm_Delete"
                  )}
                </h2>
                <p>
                  {global.config.locate(
                    appSettings && appSettings.language,
                    "Are you sure you want to delete this client?"
                  )}
                </p>
                <div className="delete-modal-buttons">
                  <button
                    className="buttons-rejected"
                    onClick={handleConfirmDelete}
                    disabled={isSubmitLoading}
                  >
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      global.config.locate(
                        appSettings && appSettings.language,
                        "Delete Client"
                      )
                    )}
                  </button>
                  <button
                    onClick={handleCancelDelete}
                    disabled={isSubmitLoading}
                  >
                    {global.config.locate(
                      appSettings && appSettings.language,
                      "Cancel"
                    )}
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="client-name-section">
          <div className="client-image">
            <div className="profile-photo-sec">
              {((clientView &&
                clientView.company_logo !== "null" &&
                clientView.company_logo !== null) ||
                uploadedImageUrl) &&
                !isLoading &&
                !removeProfileImage ? (
                <div className="profile-photo-sec-edit-outer">
                  <div
                    className="pic-edit picart"
                    onClick={!fileSelectIsLoading && handleDropdown}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                    >
                      <circle cx="14.5" cy="14.5" r="14.5" fill="#6479F8" />
                      <path
                        d="M22.7194 10.1524L19.2559 6.66847C19.2063 6.61849 19.1405 6.59104 19.0701 6.59104C18.9998 6.59104 18.9344 6.6185 18.8847 6.66848L16.8328 8.73279L16.8303 8.74018L16.7894 8.77644L8.86392 16.7497C8.82719 16.7866 8.80235 16.8331 8.7922 16.8838L7.91485 21.2513C7.89736 21.3382 7.9243 21.4273 7.98658 21.4903C8.03626 21.5399 8.10204 21.5673 8.17236 21.5673C8.18986 21.5673 8.207 21.5656 8.2231 21.5624L12.5654 20.6792C12.6164 20.669 12.6623 20.644 12.6987 20.6074L22.7194 10.5259C22.7691 10.4762 22.7961 10.4097 22.7961 10.339C22.7961 10.2682 22.7688 10.2021 22.7194 10.1524ZM12.3831 20.1777L8.50718 20.9662L9.29043 17.0668L10.4345 15.9158L13.5271 19.0271L12.3831 20.1777ZM13.898 18.6536L10.8053 15.5427L16.9801 9.33077L20.0724 12.4417L13.8976 18.6536L13.898 18.6536ZM20.4439 12.0682L17.3516 8.95733L19.0702 7.22844L22.1628 10.3393L20.4439 12.0682Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="0.4"
                      />
                    </svg>
                  </div>

                  {dropdownVisible && (
                    <div className="dropdown-edit-profile" ref={dropdownRef}>
                      {/* <button onClick={handleUploadPhoto}>Upload Photo</button> */}
                      <div className="profile-pic-edit">
                        <Link
                          className="pic-edit"
                          onClick={
                            !fileSelectIsLoading && handleProfilePicChange
                          }
                        >
                          {fileSelectIsLoading ? (
                            <div
                              style={{
                                width: "18px",
                                height: "18px",
                                border: "2px solid #6479f8",
                                borderTop: "2px solid transparent",
                                borderRadius: "50%",
                                animation: "spin 0.75s linear infinite",
                              }}
                            />
                          ) : (
                            <span>Upload Photo</span>
                          )}
                        </Link>
                      </div>
                      {/* <button onClick={!fileSelectIsLoading && handleProfilePicChange}>Delete Photo</button> */}
                      <div className="remove-pic">
                        <label for="delete1">
                          <input
                            type="checkbox"
                            checked={removeProfileImage}
                            onChange={() =>
                              setRemoveProfileImage(!removeProfileImage)
                            }
                            id="delete1"
                            hidden
                          />
                          <span>Delete Photo</span>
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="profile-pic-edit">
                  <Link
                    className="pic-edit"
                    onClick={!fileSelectIsLoading && handleProfilePicChange}
                  >
                    {fileSelectIsLoading ? (
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          border: "2px solid #6479f8",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 0.75s linear infinite",
                        }}
                      />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                      >
                        <circle cx="14.5" cy="14.5" r="14.5" fill="#6479F8" />
                        <path
                          d="M22.7194 10.1524L19.2559 6.66847C19.2063 6.61849 19.1405 6.59104 19.0701 6.59104C18.9998 6.59104 18.9344 6.6185 18.8847 6.66848L16.8328 8.73279L16.8303 8.74018L16.7894 8.77644L8.86392 16.7497C8.82719 16.7866 8.80235 16.8331 8.7922 16.8838L7.91485 21.2513C7.89736 21.3382 7.9243 21.4273 7.98658 21.4903C8.03626 21.5399 8.10204 21.5673 8.17236 21.5673C8.18986 21.5673 8.207 21.5656 8.2231 21.5624L12.5654 20.6792C12.6164 20.669 12.6623 20.644 12.6987 20.6074L22.7194 10.5259C22.7691 10.4762 22.7961 10.4097 22.7961 10.339C22.7961 10.2682 22.7688 10.2021 22.7194 10.1524ZM12.3831 20.1777L8.50718 20.9662L9.29043 17.0668L10.4345 15.9158L13.5271 19.0271L12.3831 20.1777ZM13.898 18.6536L10.8053 15.5427L16.9801 9.33077L20.0724 12.4417L13.8976 18.6536L13.898 18.6536ZM20.4439 12.0682L17.3516 8.95733L19.0702 7.22844L22.1628 10.3393L20.4439 12.0682Z"
                          fill="white"
                          stroke="white"
                          strokeWidth="0.4"
                        />
                      </svg>
                    )}
                  </Link>
                </div>
              )}

              {isLoading ? (
                <div
                  style={{
                    width: "107px",
                    height: "107px",
                    borderRadius: "50%",
                    backgroundColor: "#e5e7eb",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              ) : removeProfileImage ? (
                <div className="profile-image">
                  {/* Display a default placeholder image */}
                  <img src={profile_image} alt="Default Profile" />
                </div>
              ) : uploadedImageUrl ? (
                <div className="profile-image">
                  <img src={uploadedImageUrl} alt="Uploaded Profile " />
                </div>
              ) : (
                <div className="profile-image">
                  {clientView &&
                    clientView.company_logo !== "null" &&
                    clientView.company_logo !== null ? (
                    <img
                      src={`/uploads/clientCompyLogo/lowQuality/${clientView.company_logo}`}
                      alt="User Profile "
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "/uploads/clientCompyLogo/lowQuality/DefaultCompLogo.png";
                      }}
                    />
                  ) : (
                    <img src={profile_image} alt="User Profile " />
                  )}
                </div>
              )}
              {isLoading ? (
                <div
                  style={{
                    width: "18px",
                    height: "18px",
                    border: "2px solid #6479f8",
                    borderTop: "2px solid transparent",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                />
              ) : (
                <div className="profile-pic-edit" style={{ display: "none" }}>
                  <Link
                    className="pic-edit"
                    onClick={!fileSelectIsLoading && handleProfilePicChange}
                  >
                    {fileSelectIsLoading ? (
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          border: "2px solid #6479f8",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 0.75s linear infinite",
                        }}
                      />
                    ) : (
                      <img src={PicEdit} alt="edit" />
                    )}
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="client-right">
            {isLoading ? (
              <div
                style={{
                  width: "200px",
                  height: "24px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            ) : (
              <div className="client-text">
                {clientView.client_name && clientView.client_name}
              </div>
            )}
            {isLoading ? (
              <div
                style={{
                  width: "80px",
                  height: "31px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "100px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            ) : (
              <>
                {clientView && clientView.is_active === false ? (
                  <div
                    className="inactive-text inactive"
                    onClick={() =>
                      !isSubmitLoading && StatusChangeInactive(clientView._id)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "70px",
                          height: "31px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "100px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      "Inactive"
                    )}
                  </div>
                ) : clientView.is_active === true ? (
                  <div
                    className="active-text"
                    onClick={() =>
                      !isSubmitLoading && StatusChangeActive(clientView._id)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "70px",
                          height: "31px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "100px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      "Active"
                    )}
                  </div>
                ) : (
                  clientView.is_active
                )}
              </>
            )}
          </div>
        </div>
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          ref={fileInputRef}
        // onChange={handleFileInputChange}
        />
        <Modal
          isOpen={modalIsOpen}
          // onRequestClose={() => setModalIsOpen(false)}
          contentLabel="Image Crop Modal"
          style={{
            content: {
              height: "500%",
              width: "1000%",
              position: "fixed",
              top: "15%",
              left: "50%",
              parent: document.querySelector(".admin-outer.time.tracker"),
            },
          }}
        >
          <div>
            {image && (
              <Cropper
                ref={cropperRef}
                style={{ height: 400, width: "100%" }}
                zoomTo={0}
                initialAspectRatio={1}
                preview=".img-preview"
                src={image}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={100}
                checkOrientation={false}
                guides={true}
              />
            )}
          </div>
          <div>
            <div className="crop-btn">
              <button onClick={handleCropClick}>Crop and Upload</button>
              <button className="delete-client" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </Modal>

        <div className="accordion-client-outer">
          <div
            className="header-client-accordion"
            onClick={toggleCompanyInfoAccordion}
          >
            <span>Company Information</span>
            <img src={BottomArrow} alt="bottom-arrow" />
          </div>

          {isCompanyInfoOpen && (
            <div className="company-information-section">
              <div className="left-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={SingleUser} alt="single-user" />
                    </div>
                    <span>Commercial Name *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        id="compname"
                        className={clientNameIsValid ? "input-validation-error" : ""}
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                        ref={clientNameRef}
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={SingleUser} alt="single-user" />
                    </div>

                    <span>Legal Entity Name *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className={legalEntityNameIsValid ? "type-field input-validation-error" : "type-field"}
                        value={legalEntityName}
                        onChange={(e) => setLegalEntityName(e.target.value)}
                        ref={legalEntityNameRef}
                      />
                    </div>
                  )}
                </div>

                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={SingleUser} alt="single-user" />
                    </div>

                    <span>Short Name *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className={shortNameIsValid ? "type-field input-validation-error" : "type-field"}
                        value={shortName}
                        onChange={(e) => setShortName(e.target.value)}
                        ref={shortNameRef}
                      />
                    </div>
                  )}
                </div>

              </div>
              <div className="right-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={EmailIcon} alt="email-icon" />
                    </div>

                    <span>Email *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="email"
                        className="read-only-input"
                        value={clientView.email}
                        readOnly
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={CompanyUrl} alt="company-url" />
                    </div>
                    <span>Company Url *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className={companyWebsiteIsValid || isValidUrl ? "type-field input-validation-error" : "type-field"}
                        value={companyWebsite}
                        onChange={(e) => setCompanyWebsite(e.target.value)}
                        ref={compWebsiteRef}
                      />
                    </div>
                  )}
                  {isValidUrl && (
                    <span className="text-red-500 text-xs italic">
                      Please enter a valid URL!!
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="accordion-client-outer">
          <div
            className="header-client-accordion"
            onClick={toggleAddressAccordion}
          >
            <span>Address</span>
            <img src={BottomArrow} alt="bottom-arrow" />
          </div>

          {isAddressOpen && (
            <div className="company-information-section">
              <div className="left-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={LocationIcon} alt="location-icon" />
                    </div>

                    <span>City *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className={cityIsValid ? "type-field input-validation-error" : "type-field"}
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        ref={cityRef}
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={LocationIcon} alt="location-icon" />
                    </div>

                    <span>Country *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "26px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <div
                        className={`custom-dropdown-user-new-outer custom-dropdown-select ${countryDropdownOpen ? "open" : ""
                          }`}
                        ref={countryDropdownRef}
                      >
                        <div
                          className={`selected-option custom-dropdown-user-new${countryIsValid ? " input-validation-error" : ""}`}
                          onClick={handleToggleCountryDropdown}
                          style={{ cursor: "pointer" }}
                          ref={countryRef}
                        >
                          {country
                            ? countriesList.find((c) => c.country === country)
                              ?.country
                            : "Select Country"}
                        </div>
                        {countryDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <input
                              type="text"
                              className="search-bar"
                              placeholder="Search..."
                              value={countrySearchTerm}
                              onChange={handleCountrySearchInputChange}
                            />
                            <ul className="country-list">
                              {filteredCountries.length > 0 &&
                                filteredCountries.map((c) => (
                                  <li
                                    key={c.country}
                                    className={
                                      country === c.country
                                        ? "selected-item"
                                        : ""
                                    }
                                    onClick={() =>
                                      handleCountryChange(c.country)
                                    }
                                  >
                                    {c.country}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {states.length > 0 && (
                  <div className="outer-section">
                    <div className="text-icon">
                      <div className="icon-image">
                        <img src={LocationIcon} alt="location-icon" />
                      </div>
                      <label>State *</label>
                    </div>
                    {isLoading ? (
                      <div
                        style={{
                          width: "100%",
                          height: "43px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "8px",
                          marginLeft: "26px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      <div className="text-section">
                        <div
                          className={`custom-dropdown-user-new-outer custom-dropdown-select ${stateDropdownOpen ? "open" : ""}`}
                          ref={stateDropdownRef}
                        >
                          <div
                            className={`selected-option custom-dropdown-user-new`}
                            onClick={() => {
                              setStateDropdownOpen(!stateDropdownOpen);
                              setStateSearchTerm('');
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {state ? states.find((s) => s.state === state)?.state : 'Select State'}
                          </div>
                          {stateDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <input
                                type="text"
                                className="search-bar"
                                placeholder="Search..."
                                value={stateSearchTerm}
                                onChange={handleStateSearchInputChange}
                              />
                              <ul className="state-list">
                                {filteredStates.length > 0 &&
                                  filteredStates.map((s) => (
                                    <li
                                      key={s.state}
                                      className={state === s.state ? 'selected-item' : ''}
                                      onClick={() => {
                                        setState(s.state);
                                        setStateDropdownOpen(false);
                                      }}
                                    >
                                      {s.state}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="right-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={LocationIcon} alt="location-icon" />
                    </div>
                    <span>Address *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className={addressIsValid ? "type-field input-validation-error" : "type-field"}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        ref={addressRef}
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PostalIcon} alt="postal-icon" />
                    </div>

                    <span>Postal Code *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className={pincodeIsValid ? "type-field input-validation-error" : "type-field"}
                        value={pincode}
                        onChange={(e) => setPincode(e.target.value)}
                        ref={pincodeRef}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="accordion-client-outer">
          <div
            className="header-client-accordion"
            onClick={toggleBillingAccordion}
          >
            <span>Billing Information</span>
            <img src={BottomArrow} alt="bottom-arrow" />
          </div>

          {isBillingOpen && (
            <div className="company-information-section">
              <div className="left-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PassportIcon} alt="passport-icon" />
                    </div>

                    <span>Company VAT Number *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className="type-field"
                        value={vatNumber}
                        onChange={(e) => setVatNumber(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PassportIcon} alt="passport-icon" />
                    </div>

                    <span>Company VAT applicable Percentage *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="number"
                        className="type-field"
                        onWheel={numberInputOnWheelPreventChange}
                        value={vatPercentage}
                        onChange={(e) => setVatPercentage(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="inner-detail-outer">
                    <div className="text-icon">
                      <div className="icon-image">
                        <img src={PaymentIcon} alt="payment-icon" />
                      </div>

                      <span>Preferred Currency *</span>
                    </div>

                    <div className="inner-detail ">
                      <span className="icon"></span>
                      {isLoading ? (
                        <div
                          style={{
                            width: "100%",
                            height: "43px",
                            backgroundColor: "#e5e7eb",
                            borderRadius: "8px",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        />
                      ) : (
                        <div className="inner-detail-inner custom-dropdown1">
                          <div className="tooltip-container">
                            <div
                              className={`custom-dropdown-user-new-outer custom-dropdown-select ${currencyDropdownOpen ? "open" : ""
                                }`}
                              ref={currencyDropdownRef}
                            >
                              <div
                                className={`selected-option custom-dropdown-user-new${currencyIsValid ? " input-validation-error" : ""}`}
                                onClick={() =>
                                  setCurrencyDropdownOpen(!currencyDropdownOpen)
                                }
                                ref={currencyRef}
                              >
                                {preferredCurrency
                                  ? currencyList.find(
                                    (c) =>
                                      c.currencyCode === preferredCurrency
                                  )?.currencyCode
                                  : "Select Currency"}
                              </div>
                              {currencyDropdownOpen && (
                                <div className="custom-dropdown-new">
                                  <input
                                    type="text"
                                    className="search-bar"
                                    placeholder="Search..."
                                    value={currencySearchTerm}
                                    onChange={handleCurrencySearchInputChange}
                                  />
                                  <ul className="currency-list">
                                    {filteredCurrencies.length > 0 &&
                                      filteredCurrencies.map((c) => (
                                        <li
                                          key={c.currencyCode}
                                          className={
                                            currency === c.currencyCode
                                              ? "selected-item"
                                              : ""
                                          }
                                          onClick={() => {
                                            setPreferredCurrency(
                                              c.currencyCode
                                            );
                                            setCurrencyDropdownOpen(false);
                                          }}
                                        >
                                          {`${c.currencyCode} (${c.currencyName})`}
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={CostIcon} alt="cost-icon" />
                    </div>

                    <span>Preferred Payment Method *</span>
                  </div>
                  <div className="text-section">
                    {isLoading ? (
                      <div
                        style={{
                          width: "100%",
                          height: "43px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "8px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      <div className="custom-dropdown1">
                        <div
                          ref={paymentMethodDropdownRef}
                          className={`custom-dropdown-user-new-outer custom-dropdown-select ${paymentMethodDropdownOpen ? "open" : ""
                            }`}
                        >
                          <div
                            className="selected-option custom-dropdown-user-new"
                            onClick={togglePaymentMethodDropdown}
                          >
                            {paymentMethod
                              ? paymentMethod
                              : "Select Payment Method"}
                          </div>
                          {paymentMethodDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <ul className="type-list">
                                <li
                                  onClick={() =>
                                    selectPaymentMethodOption("Bank Transfer")
                                  }
                                >
                                  Bank Transfer
                                </li>
                                <li
                                  onClick={() =>
                                    selectPaymentMethodOption("Wise Transfer")
                                  }
                                >
                                  Wise Transfer
                                </li>
                                <li
                                  onClick={() =>
                                    selectPaymentMethodOption("Card")
                                  }
                                >
                                  Card
                                </li>
                                {/* Add more PaymentMethod options as needed */}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="right-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={SingleUser} alt="single-user" />
                    </div>

                    <span>Billing contact - Full Name *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className="type-field"
                        value={billingContactName}
                        onChange={(e) => setBillingContactName(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={CompanyIcon} alt="company-icon" />
                    </div>

                    <span>Billing contact - Position *</span>
                  </div>
                  <div className="text-section">
                    {isLoading ? (
                      <div
                        style={{
                          width: "100%",
                          height: "43px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "8px",
                          marginLeft: "29px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      // <div className="custom-dropdown1">
                      //   <div ref={billingContactDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${billingContactDropdownOpen ? 'open' : ''}`}>
                      //     <div className={`selected-option custom-dropdown-user-new ${billContPosIsValid} ? "input-validation-error" : ""`} onClick={toggleBillingContactDropdown} ref={billContPosRef}>
                      //       {billingContactPosition ? position.find((pos) => pos._id === billingContactPosition)?.position_name : 'Select Billing Contact Position'}
                      //     </div>
                      //     {billingContactDropdownOpen && (
                      //       <div className="custom-dropdown-new">
                      //         <ul className="type-list">
                      //           {position.length > 0 &&
                      //             position.map((pos) => (
                      //               <li
                      //                 key={pos._id}
                      //                 className={billingContactPosition === pos._id ? 'selected-item' : ''}
                      //                 onClick={() => {
                      //                   setBillingContactPosition(pos._id);
                      //                   setBillingContactDropdownOpen(false);
                      //                 }}>
                      //                 {pos.position_name}
                      //               </li>
                      //             ))}
                      //           {/* Add more language options as needed */}
                      //         </ul>
                      //       </div>
                      //     )}
                      //   </div>
                      // </div>
                      <div className="text-section">
                        <input
                          type="text"
                          className="type-field"
                          value={billingContactPosition}
                          onChange={(e) =>
                            setBillingContactPosition(e.target.value)
                          }
                          ref={billContPosRef}
                          required
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={EmailIcon} alt="email-icon" />
                    </div>

                    <span>Billing contact - Email Address *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className="type-field"
                        value={billingContactEmail}
                        onChange={(e) => setBillingContactEmail(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PhoneIcon} alt="Phone-icon" />
                    </div>

                    <span>Contact Number *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "26px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <PhoneInput
                        placeholder="Enter phone number"
                        value={mobileNo}
                        onChange={setMobileNo}
                        required
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="accordion-client-outer">
          <div
            className="header-client-accordion"
            onClick={toggleSignatoryAccordion}
          >
            <span>Signatory Information</span>
            <img src={BottomArrow} alt="bottom-arrow" />
          </div>

          {isSignatoryOpen && (
            <div className="company-information-section">
              <div className="left-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={SingleUser} alt="single-user" />
                    </div>
                    <span>Full Name *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        id="signatoryName"
                        className="type-field"
                        value={signatoryUserName}
                        onChange={(e) => setSignatoryUserName(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={CompanyIcon} alt="company-icon" />
                    </div>

                    <span>Position *</span>
                  </div>
                  <div className="text-section">
                    {isLoading ? (
                      <div
                        style={{
                          width: "100%",
                          height: "43px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "8px",
                          marginLeft: "29px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      // <div className="custom-dropdown1">
                      //   <div ref={signatoryPositionDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${signatoryPositionDropdownOpen ? 'open' : ''}`}>
                      //     <div className={`selected-option custom-dropdown-user-new ${signUserPosIsValid} ? "input-validation-error" : ""`} onClick={toggleSignatoryPositionDropdown} ref={signUserPosRef}>
                      //       {signatoryUserPosition ? position.find((pos) => pos._id === signatoryUserPosition)?.position_name : 'Select Position'}
                      //     </div>
                      //     {signatoryPositionDropdownOpen && (
                      //       <div className="custom-dropdown-new">
                      //         <ul className="type-list">
                      //           {position.length > 0 &&
                      //             position.map((pos) => (
                      //               <li
                      //                 key={pos._id}
                      //                 className={signatoryUserPosition === pos._id ? 'selected-item' : ''}
                      //                 onClick={() => {
                      //                   setSignatoryUserPosition(pos._id);
                      //                   setSignatoryPositionDropdownOpen(false);
                      //                 }}>
                      //                 {pos.position_name}
                      //               </li>
                      //             ))}
                      //         </ul>
                      //       </div>
                      //     )}
                      //   </div>
                      // </div>
                      <div className="text-section">
                        <input
                          type="text"
                          className="type-field"
                          value={signatoryUserPosition}
                          onChange={(e) =>
                            setSignatoryUserPosition(e.target.value)
                          }
                          ref={signUserPosRef}
                          required
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="right-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={EmailIcon} alt="email-icon" />
                    </div>
                    <span>Email *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="email"
                        className="type-field"
                        value={signatoryEmail}
                        onChange={(e) => setSignatoryEmail(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PhoneIcon} alt="phone-icon" />
                    </div>

                    <span>Contact Number *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "26px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <PhoneInput
                        placeholder="Enter phone number"
                        value={signatoryMobileNo}
                        onChange={setSignatoryMobileNo}
                        required
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="accordion-client-outer">
          <div
            className="header-client-accordion"
            onClick={togglePointOfContactAccordion}
          >
            <span>Point of Contact</span>
            <img src={BottomArrow} alt="bottom-arrow" />
          </div>

          {isPointOfContactOpen && (
            <div className="company-information-section">
              <div className="left-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={SingleUser} alt="single-user" />
                    </div>
                    <span>Full Name *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="text"
                        className="type-field"
                        value={pocUserName}
                        onChange={(e) => setPocUserName(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={CompanyIcon} alt="company-icon" />
                    </div>

                    <span>Position *</span>
                  </div>
                  <div className="text-section">
                    {isLoading ? (
                      <div
                        style={{
                          width: "100%",
                          height: "43px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "8px",
                          marginLeft: "29px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      // <div className="custom-dropdown1">
                      //   <div ref={positionContactDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${positionContactDropdownOpen ? 'open' : ''}`}>
                      //     <div className={`selected-option custom-dropdown-user-new ${pocUserPosIsValid} ? "input-validation-error" : ""`} onClick={togglePositionContactDropdown} ref={pocUserPosRef}>
                      //       {pocUserPosition ? position.find((pos) => pos._id === pocUserPosition)?.position_name : 'Select Contact Point Position'}
                      //     </div>
                      //     {positionContactDropdownOpen && (
                      //       <div className="custom-dropdown-new">
                      //         <ul className="type-list">
                      //           {position.length > 0 &&
                      //             position.map((pos) => (
                      //               <li
                      //                 key={pos._id}
                      //                 className={pocUserPosition === pos._id ? 'selected-item' : ''}
                      //                 onClick={() => {
                      //                   setPocUserPosition(pos._id);
                      //                   setPositionContactDropdownOpen(false);
                      //                 }}
                      //               >
                      //                 {pos.position_name}
                      //               </li>
                      //             ))}
                      //         </ul>
                      //       </div>
                      //     )}
                      //   </div>
                      // </div>
                      <div className="text-section">
                        <input
                          type="text"
                          className="type-field"
                          value={pocUserPosition}
                          onChange={(e) => setPocUserPosition(e.target.value)}
                          ref={pocUserPosRef}
                          required
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="right-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={EmailIcon} alt="email-icon" />
                    </div>

                    <span>Email *</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <input
                        type="email"
                        className="type-field"
                        value={pocEmail}
                        onChange={(e) => setPocEmail(e.target.value)}
                        required
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="accordion-client-outer">
          <div
            className="header-client-accordion"
            onClick={toggleSecurityAccordion}
          >
            <span>Security</span>
            <img src={BottomArrow} alt="bottom-arrow" />
          </div>

          {isSecurityOpen && (
            <div className="company-information-section">
              <div className="left-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PasswordLock} alt="single-user" />
                    </div>
                    <span>Password</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <div className="inner-detail-inner pass-eye">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="type-field"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          ref={passwordRef}
                        />
                        <img
                          src={showPassword ? EyeCrossed : EyeIcon}
                          className="password-toggle-icon"
                          alt="Toggle Password"
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </div>
                      {passwordError && (
                        <span>{passwordError}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="right-section">
                <div className="outer-section">
                  <div className="text-icon">
                    <div className="icon-image">
                      <img src={PasswordLock} alt="email-icon" />
                    </div>

                    <span>Confirm Password</span>
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "43px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "8px",
                        marginLeft: "29px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  ) : (
                    <div className="text-section">
                      <div className="text-section">
                        <input
                          type="password"
                          className="type-field"
                          value={passwordConfirmation}
                          onChange={(e) => setPasswordConfirmation(e.target.value)}
                          ref={passwordConfirmationRef}
                          required={!!password}
                        />
                        {passwordMatchError && (
                          <span style={{ color: "red" }}> {passwordMatchError} </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="accordion-client-outer bottom-field">
          <div className="header-client-accordion">
            <span>Additional Notes</span>
          </div>

          <div className="additional-notes-section">
            {isLoading ? (
              <div
                style={{
                  width: "92%",
                  height: "65px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  marginLeft: "40px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            ) : (
              <div className="total-section">
                <textarea
                  id="additionalInformation"
                  name="additionalInformation"
                  value={additionalInfo}
                  onChange={(e) => setAdditionalInfo(e.target.value)}
                ></textarea>
              </div>
            )}
          </div>
        </div>

        <div className="button-section-outer">
          <Link
            to={`/client/details/${encodeURIComponent(
              AES.encrypt(id, "encryptionKey").toString().replace(/\//g, "%2F")
            )}`}
          >
            <div className="cancel-button">
              <span>Cancel</span>
            </div>
          </Link>
          <button type="submit" className="submit-button submit-button-new" disabled={isSubmitLoading}>
            {isSubmitLoading ? (
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  border: "2px solid #ffffff",
                  borderTop: "2px solid transparent",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto",
                }}
              />
            ) : (
              <>
                <div className="button-tick">
                  <img src={WhiteTick} alt="tick-icon-white" />
                </div>
                <div className="button-text">
                  <span>Save Changes</span>
                </div>
              </>
            )}
          </button>
        </div>
      </form>

      {/* ── HubSpot Map Company Modal ──────────────────────────────────────── */}
      <Modal
        className="client-modal"
        isOpen={hubspotMapModalOpen}
        onRequestClose={closeHubspotMapModal}
        contentLabel="Map to HubSpot Company"
        style={{
          content: {
            width: "30%",
            position: "fixed",
            top: "50%",
            left: "50%",
            parent: document.querySelector(".admin-outer.time.tracker"),
          },
        }}
      >
        <div className="modal">
          <div className="modal-close-invite outter-modal-main">
            <a onClick={closeHubspotMapModal} style={{ cursor: "pointer" }}>
              <img src={crssrImage} alt="Close" />
            </a>
          </div>
          <div className="modal-client-head">
            <h2>Map to HubSpot Company</h2>
          </div>
          <div className="form-field-client-outer">
            <div className="form-field-client" style={{ marginBottom: "12px" }}>
              <label className="form-label">Search HubSpot Companies</label>
              <input
                type="text"
                className="form-input"
                autoFocus
                placeholder="Search by name or domain..."
                value={hubspotCompanySearch}
                onChange={handleHubspotCompanySearchChange}
                onFocus={() => { if (!hubspotCompanyResults.length && !hubspotCompanySearch) searchHubspotCompanies(""); }}
              />
            </div>
            <div style={{ maxHeight: "260px", overflowY: "auto", border: "1px solid #e8e8e8", borderRadius: "6px", marginBottom: "16px" }}>
              {hubspotCompanySearchLoading ? (
                <div style={{ padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: "13px" }}>Searching...</div>
              ) : hubspotCompanyResults.length === 0 ? (
                <div style={{ padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: "13px" }}>
                  {hubspotCompanySearch ? "No companies found." : "Type to search HubSpot companies."}
                </div>
              ) : (
                hubspotCompanyResults.map((company, idx) => {
                  const isSelected = hubspotSelectedCompany?.id === company.id;
                  return (
                    <div
                      key={company.id}
                      onClick={() => setHubspotSelectedCompany(isSelected ? null : company)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "10px 14px",
                        cursor: "pointer",
                        backgroundColor: isSelected ? "#fff5f2" : idx % 2 === 0 ? "#ffffff" : "#f9fafb",
                        borderBottom: idx < hubspotCompanyResults.length - 1 ? "1px solid #f3f4f6" : "none",
                        borderLeft: isSelected ? "3px solid #ff7a59" : "3px solid transparent",
                      }}
                    >
                      <div style={{
                        width: "30px", height: "30px", borderRadius: "6px", flexShrink: 0,
                        background: isSelected ? "#ff7a59" : "#e8e8e8",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: "13px", fontWeight: 700,
                        color: isSelected ? "#fff" : "#6b7280",
                      }}>
                        {(company.name || "?")[0].toUpperCase()}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: "13px", fontWeight: isSelected ? 600 : 400, color: "#282828", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {company.name}
                        </div>
                        <div style={{ fontSize: "11px", color: "#96a4b2", marginTop: "2px" }}>
                          {company.domain || company.website || "No domain"}
                          {company.city ? ` · ${company.city}` : ""}
                        </div>
                      </div>
                      {isSelected && <span style={{ fontSize: "14px", color: "#ff7a59", flexShrink: 0, fontWeight: 700 }}>✓</span>}
                    </div>
                  );
                })
              )}
            </div>
            {hubspotSelectedCompany && (
              <div style={{ marginBottom: "14px", fontSize: "12px", color: "#6b7280" }}>
                Selected: <strong style={{ color: "#282828" }}>{hubspotSelectedCompany.name}</strong>
              </div>
            )}
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={closeHubspotMapModal}
                style={{ padding: "9px 18px", borderRadius: "6px", border: "1px solid #e8e8e8", background: "#fff", color: "#282828", fontSize: "13px", cursor: "pointer", fontWeight: 500 }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSaveHubspotMap}
                disabled={!hubspotSelectedCompany || hubspotMapSaving}
                style={{
                  padding: "9px 18px",
                  borderRadius: "6px",
                  border: "none",
                  background: hubspotSelectedCompany && !hubspotMapSaving ? "#405BFF" : "#e8e8e8",
                  color: hubspotSelectedCompany && !hubspotMapSaving ? "#fff" : "#9ca3af",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: hubspotSelectedCompany && !hubspotMapSaving ? "pointer" : "not-allowed",
                }}
              >
                {hubspotMapSaving ? "Saving..." : "Map Company"}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ── HubSpot Mapped Details Modal ───────────────────────────────────── */}
      <Modal
        className="client-modal"
        isOpen={hubspotDetailsModalOpen}
        onRequestClose={() => setHubspotDetailsModalOpen(false)}
        contentLabel="HubSpot Company Details"
        style={{
          content: {
            width: "30%",
            position: "fixed",
            top: "50%",
            left: "50%",
            parent: document.querySelector(".admin-outer.time.tracker"),
          },
        }}
      >
        <div className="modal">
          <div className="modal-close-invite outter-modal-main">
            <a onClick={() => setHubspotDetailsModalOpen(false)} style={{ cursor: "pointer" }}>
              <img src={crssrImage} alt="Close" />
            </a>
          </div>
          <div className="modal-client-head">
            <h2>HubSpot Company</h2>
          </div>
          <div className="form-field-client-outer">
            <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px", backgroundColor: "#f9fafb", border: "1px solid #e8e8e8", borderRadius: "8px", marginBottom: "16px" }}>
              <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: "#fff5f2", border: "1px solid #ffb8a0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: 700, color: "#ff7a59", flexShrink: 0 }}>
                {(hubspotMappedCompanyName || "?")[0]?.toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize: "14px", fontWeight: 600, color: "#282828" }}>{hubspotMappedCompanyName || "HubSpot Company"}</div>
                <div style={{ fontSize: "11px", color: "#96a4b2", marginTop: "3px" }}>HubSpot ID: {hubspotMappedCompanyId}</div>
              </div>
            </div>
            <div style={{ padding: "12px 14px", backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "6px", fontSize: "13px", color: "#15803d", marginBottom: "20px", lineHeight: "1.5" }}>
              This client is linked to a HubSpot company. Projects created from HubSpot will automatically be associated with this client.
            </div>
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={handleRemoveHubspotMap}
                style={{ padding: "9px 18px", borderRadius: "6px", border: "1px solid #fca5a5", background: "#fff", color: "#dc2626", fontSize: "13px", fontWeight: 500, cursor: "pointer" }}
              >
                Remove Mapping
              </button>
              <button
                type="button"
                onClick={handleRemapClick}
                style={{ padding: "9px 18px", borderRadius: "6px", border: "none", background: "#405BFF", color: "#fff", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
              >
                Remap Company
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ClientProfile;
